import React from "react";
import { SidebarProvider, SidebarTrigger } from "../components/ui/sidebar";
import { AppSidebar } from "./app-sidebar";
import { FusionBody } from "../components/ui/fusion-body";
import { Separator } from "../components/ui/separator";
import { ThemeProvider } from "@fluentui/react";
import { theme } from "../../utils/fluent-ui-theme";
import type { HelpArticle } from "../../help-types";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Toaster } from "sonner";
import { ErrorsAlert } from "./errors-alert";
import { cn } from "@/lib/utils";

export type FusionLayoutProps = React.PropsWithChildren<{
    suggestedHelpArticles?: HelpArticle[];
    // TODO: Add more complex breadcrumbs
    breadcrumb: string;
    fullWidth?: boolean;
    // Disables some Tailwind preflight styles to preserve classic look
    classic?: boolean;
    className?: string;
}>;

export const FusionLayout = ({
    children,
    suggestedHelpArticles,
    breadcrumb,
    fullWidth,
    classic,
    className,
}: FusionLayoutProps): JSX.Element => {
    return (
        <ThemeProvider theme={theme}>
            <FusionBody>
                <SidebarProvider>
                    <AppSidebar suggestedHelpArticles={suggestedHelpArticles} />
                    <Card
                        className={cn(
                            "m-2 flex h-[calc(100%-16px)] w-full flex-col overflow-auto bg-white shadow",
                            className,
                        )}
                    >
                        <CardHeader>
                            <div className="flex items-center gap-2">
                                <SidebarTrigger />
                                <Separator orientation="vertical" className="mr-2 h-4" />
                                <div className="text-foreground grow text-sm">{breadcrumb}</div>
                            </div>
                        </CardHeader>
                        <ErrorsAlert className="p-4" />
                        <CardContent
                            className={cn(
                                "flex h-full flex-col overflow-auto",
                                fullWidth && "p-0",
                                classic && "classic",
                            )}
                        >
                            {children}
                        </CardContent>
                    </Card>
                </SidebarProvider>
                <Toaster richColors />
            </FusionBody>
        </ThemeProvider>
    );
};
